import React from 'react';
import { tiktokLiveData } from '../data/mock';
import { UserCheck, PlayCircle, Target, BarChart, Settings, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';

const iconMap = {
  userCheck: UserCheck,
  playCircle: PlayCircle,
  target: Target,
  barChart: BarChart,
  settings: Settings,
  trendingUp: TrendingUp
};

const TikTokLive = ({ onCTAClick }) => {
  return (
    <section id="tiktok-live" className="py-24 lg:py-32 bg-gradient-to-b from-black via-red-950/10 to-black relative overflow-hidden">
      {/* Decorative Top Border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-red/30 to-transparent"></div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-block mb-4">
            <span className="text-xs uppercase tracking-widest text-accent-red font-semibold bg-accent-red/10 px-4 py-2 rounded-full border border-accent-red/20">
              Zusätzlicher Geschäftsbereich
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {tiktokLiveData.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-accent-red mx-auto mb-8"></div>
          <p className="text-xl lg:text-2xl text-white/90 max-w-4xl mx-auto mb-4 font-light">
            {tiktokLiveData.subtitle}
          </p>
          <p className="text-base lg:text-lg text-white/70 max-w-3xl mx-auto leading-relaxed">
            {tiktokLiveData.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto mb-12 lg:mb-16">
          {tiktokLiveData.services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="bg-gradient-to-br from-gray-900/80 to-black/80 backdrop-blur-sm border border-accent-red/20 rounded-2xl p-8 hover:border-accent-red/40 transition-all hover:-translate-y-1 group"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-accent-red/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-accent-red/20 transition-colors">
                  <IconComponent className="text-accent-red" size={26} />
                </div>

                {/* Title */}
                <h3 className="text-xl lg:text-2xl font-bold text-white mb-4 group-hover:text-accent-red transition-colors">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-white/70 leading-relaxed text-base">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button 
            onClick={onCTAClick}
            size="lg"
            className="bg-accent-red hover:bg-accent-red/90 text-white px-10 lg:px-12 py-6 lg:py-7 rounded-full text-base lg:text-lg font-semibold tracking-wide transition-all hover:scale-105 shadow-2xl shadow-accent-red/30"
          >
            {tiktokLiveData.cta}
          </Button>
        </div>
      </div>

      {/* Decorative Bottom Border */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-red/30 to-transparent"></div>
    </section>
  );
};

export default TikTokLive;
